angular.module('register.constants', [])
    .constant('registerStateTypeEnum', {
        None: 0,
        Here: 1,
        NotHere: 2,
        Late: 3,
        Excused: 4
    });